import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import * as api from "../api/api";

const ProtectedRoute = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    let mounted = true;
    api
      .getCurrentAdmin()
      .then((res) => {
        if (mounted && res && res.user && res.user.role === "admin") {
          setOk(true);
        }
      })
      .catch(() => {
        // not authenticated
      })
      .finally(() => {
        if (mounted) setChecking(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (checking) return null; // or a loader
  if (!ok) return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
